const { debounce } = window.BAO.Utils

export class CartNote extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.setContentHeight()
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(window, 'resize', this.setContentHeight.bind(this))

    if (this.els.button !== undefined) {
      this.listeners.add(
        this.els.button.element,
        'click',
        this.handleClick.bind(this),
      )
    }

    if (this.els.save !== undefined) {
      this.listeners.add(
        this.els.save.element,
        'click',
        this.handleSave.bind(this),
      )
    }

    if (this.els.textarea !== undefined) {
      this.listeners.add(
        this.els.textarea.element,
        'input',
        this.handleInput.bind(this),
      )
    }
  }

  handleSave (e) {
    e.preventDefault()
    const textarea = this.els.textarea.element
    window.BAO.Cart.updateCartAttributes({ notes_attr: textarea.value })

    if (
      this.els.message.element.classList.contains('crt-Note_SaveMessage-show')
    ) { return }
    this.showSuccessMessage()
  }

  handleInput (e) {
    if (
      this.els.message.element.classList.contains('crt-Note_SaveMessage-show')
    ) {
      this.hideSuccessMessage()
    }

    if (this.els.save !== undefined) return
    debounce(e => {
      window.BAO.Cart.updateCartAttributes({ notes_attr: e.target.value })
    }, 500)
  }

  handleClick (e) {
    e.preventDefault()
    const currentState =
      this.CartNoteContainer.getAttribute('aria-expanded') === 'true'

    this.CartNoteContainer.setAttribute('aria-expanded', !currentState)
  }

  setContentHeight () {
    let maxHeight = 0

    this.els.content.elements.forEach(itemEl => {
      maxHeight += itemEl.offsetHeight
    })

    if (maxHeight > 0) {
      this.CartNoteContainer.style.setProperty('--Max_Height', `${maxHeight}px`)
    }
  }

  hideSuccessMessage () {
    this.els.message.element.classList.remove('crt-Note_SaveMessage-show')
  }

  showSuccessMessage () {
    this.els.message.element.classList.add('crt-Note_SaveMessage-show')
  }

  get CartNoteContainer () {
    return this.els.container.element
  }
}

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', CartNote)
}
